import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="recurring-schedule--root"
export default class extends Controller {
  static values = { timeZone: String }
  static targets = ["pair"]

  onStudentInput(event) {
    this.timeZoneValue = event.target.dataset.timeZone
    this.pairTargets.forEach(elem => this.updateTimeZone(elem))
  }

  pairTargetConnected(elem) {
    this.updateTimeZone(elem, this.timeZoneValue)
  }

  updateTimeZone(elem) {
    elem.setAttribute("data-recurring-schedule--pair-time-zone-value", this.timeZoneValue)
  }
}
